
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

  position:relative;

  display:block;

  border-radius:0.75rem;

  background-color:var(--neutral-white);

  padding:1rem;
}@media (min-width: 768px) {:host {

    padding:1.5rem;
  }:host {

    padding-bottom:4rem;
  }
}:host{

  box-shadow:var(--brand-shadow);
}

.staff-card-image {

  position:relative;

  margin-bottom:0.5rem;

  height:100%;

  max-height:100%;

  width:100%;

  max-width:100%;

  overflow:hidden;

  border-radius:9999px;

  height:60px;

  width:60px;

  min-width:60px;
}

@media (min-width: 640px) {.staff-card-image {

    height:75px;
  }.staff-card-image {

    min-height:75px;
  }.staff-card-image {

    width:75px;
  }.staff-card-image {

    min-width:75px;
  }
}

figure {

  position:absolute;

  height:100%;

  width:100%;
}

img {

  position:absolute;

  height:100%;

  width:100%;

  object-fit:cover;
}

.staff-card-top-section {

  display:flex;
}

.staff-card-info-section {

  width:100%;

  padding-left:1rem;
}

.staff-card-headline {

  font-family:var(--ff-display);

  font-size:var(--fs-lg);

  line-height:var(--lh-lg);

  font-weight:var(--fw-bold);

  color:var(--primary-blue-light-2);

  text-decoration-line:none;
}

@media (min-width: 768px) {.staff-card-headline {

    font-size:var(--fs-xl);

    line-height:var(--lh-xl);
  }
}

.staff-card-division {

  font-family:var(--ff-display);

  font-size:var(--fs-base);

  line-height:var(--lh-base);

  font-weight:var(--fw-medium);

  color:var(--neutral-gray-1);

  font-weight:var(--fw-semibold);
}

@media (min-width: 768px) {.staff-card-division {

    margin-bottom:0.75rem;
  }.staff-card-division {

    font-size:var(--fs-lg);

    line-height:var(--lh-lg);
  }.staff-card-division {

    line-height:1.25rem;
  }
}

.staff-card-location, .staff-card-description {

  margin-bottom:0.75rem;

  display:none;

  color:var(--neutral-gray-1);
}

@media (min-width: 768px) {.staff-card-location, .staff-card-description {

    display:block;
  }
}

.mobile-links .staff-card-description {

  display:block;
}

.mobile-links .staff-card-cta-section {

  position:static;
}

.mobile-links .staff-card-cta-section {

  display:block;
}

@media (min-width: 768px) {.mobile-links .staff-card-cta-section {

    display:flex;
  }
}

.staff-card-location--empty {

  display:none;
}

.staff-card-main-location {

  display:none;

  font-family:var(--ff-body);

  font-size:var(--fs-lg);

  line-height:var(--lh-lg);

  font-weight:var(--fw-medium);

  color:var(--primary-blue);

  font-weight:var(--fw-semibold);
}

@media (min-width: 768px) {.staff-card-main-location {

    display:block;
  }
}

.staff-card-cta-section {

  position:absolute;

  bottom:1rem;

  left:1rem;

  right:1rem;

  display:none;

  align-items:center;

  justify-content:space-between;

  gap:1rem;

  border-top-width:1px;

  border-left-width:0px;

  border-right-width:0px;

  border-bottom-width:0px;

  border-style:solid;

  border-color:var(--neutral-gray-4);

  padding-top:0.75rem;
}

@media (min-width: 768px) {.staff-card-cta-section {

    display:flex;
  }
}

@media (min-width: 1024px) {.staff-card-cta-section {

    left:1.5rem;
  }.staff-card-cta-section {

    right:1.5rem;
  }
}

.font-medium {

  font-weight:var(--fw-semibold);
}

.phone {

  display:none;

  padding-top:1rem;

  padding-bottom:1rem;

  text-align:center;

  font-size:var(--fs-lg);

  line-height:var(--lh-lg);
}

.phone.show {

  position:absolute;

  top:0px;

  bottom:0px;

  left:0px;

  right:0px;

  display:flex;

  flex-direction:column;

  justify-content:center;

  border-radius:1rem;

  border-right-width:4px;

  background-color:var(--neutral-white);

  padding:3rem;

  vertical-align:middle;
}

.staff-icon-close {

  position:absolute;

  top:1rem;

  right:1rem;

  cursor:pointer;
}

::slotted([slot='staff-card-appointment-phone']) {

  padding-top:0.5rem;

  text-align:center;

  font-size:var(--fs-lg);

  line-height:var(--lh-lg);

  font-weight:var(--fw-bold);

  color:var(--primary-blue-dark);
}
`;